import { DashboardGridColumn } from './dashboard-grid-column';

export class DashboardGridRow {
	columns: DashboardGridColumn[] = [];
	isExpanded                     = false;
}
